import Vue from 'vue'
import Router from 'vue-router'
import RestaurantPage from '@/components/RestaurantPage'
import MenuPage from '@/components/MenuPage'
import DeliveryPage from '@/components/DeliveryPage'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'RestaurantPage',
      components: {
        default: RestaurantPage
      }
    },
    {
      path: '/menu',
      name: 'MenuPage',
      components: {
        default: MenuPage
      },

    },
    {
      path: '/delivery',
      name: 'DeliveryPage',
      components: {
        default: DeliveryPage
      },

    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js